import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const documentValidationState = atom<boolean>({
  key: 'documentValidationState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
